export default __webpack_public_path__ + "static/media/Authentic-Sans-90.2f67d753.woff";